export const timesheetStatusTranslations: Record<string, string> = {
  NotSubmitted: 'Não Submetida',
  SubmittedAndBlocked: 'Submetida e Bloqueada',
  Approved: 'Aprovada',
  Submitted: 'Submetida',
  SubmittedWithoutChanges: 'Submetida sem Alterações',
};
